export default function (value: any, strTrue: string, strFalse, options) {
    if (value) {
        return strTrue;
    } else {
        return strFalse;
    }
}
